import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';

type InventoryLocation = { location: string; inventory: number };

type PriceBreak = {
  minQuantity: number | null;
  maxQuantity: number | null;
  piecePrice: number | null;
};

type Brand = {
  id: number;
  name: string;
  thumbnailUrl: string;
};

type Product = {
  brand: Brand;
  sku: string;
  thumbnailUrl: string;
};

type Distributor = { logoUrl: string; name: string };

type RealTimePricingDetailsResponse = {
  availabilityResponseStatus: 'does_not_exist' | 'success' | 'error';
  availableQuantity: number;
  defaultPurchasedComponentQuantity: number;
  distributor: Distributor;
  id: number;
  inventoryLocations: InventoryLocation[];
  priceBreaks: PriceBreak[];
  product: Product;
  lastRefreshedTime: string;
};

export const useGetRealTimePricingDetails = (
  realTimePricingPlanId,
  { query, requestOptions } = {},
) => {
  const request = useRequest(requestOptions);

  return useQuery<RealTimePricingDetailsResponse, Error>({
    queryKey: ['fetchRealTimePricingDetails', realTimePricingPlanId, query],
    queryFn: () =>
      request(`/quotes/real_time_pricing_plans/${realTimePricingPlanId}`, {
        query,
      }),
    enabled: !!realTimePricingPlanId,
  });
};
